import { action, observable, makeObservable } from 'mobx';
import { FC } from 'react';

import { ICommonPopupsProps } from '../../components/PopupManager/PopupManager.types';
import { PopupStore } from './Popup/PopupStore';

export interface IPopupOptions<TParams = any, TResult = any> {
  params?: TParams;
  onClose?(data?: TResult): void;
  onBack?(data?: TResult): void;
}

class CPopups {
  @observable data: PopupStore[] = [];
  @observable uiLayer = 0; // number of open popups

  constructor() {
    makeObservable(this);
  }

  @action
  openPopup<T>(Component: FC<ICommonPopupsProps<T>>, options?: IPopupOptions<T>): PopupStore<T> {
    const popup = new PopupStore<T>(this, Component, options);
    this.data.push(popup);
    return popup;
  }

  @action
  closePopup(popup: PopupStore<any>): void {
    this.data = this.data.filter((p) => p !== popup);
  }

  @action reset(): void {
    this.data = [];
  }

  @action
  addLayer = (): void => {
    this.uiLayer = this.uiLayer + 1;
  };

  @action
  removeLayer = (): void => {
    this.uiLayer = Math.max(0, this.uiLayer - 1);
  };
}

export const PopupsStore = new CPopups();
export type IPopupsStore = typeof PopupsStore;
